import { connect } from 'react-redux';
import { goBack, push } from 'redux-first-history';
import RentAmountPage from '@rental-manager/pages/Onboarding/RentAmountPage/component';
import { DEFAULT_ERROR, PAYMENT_SETTINGS_UPDATED } from '@rental-manager/constants/NotificationConstants';
import paths from '@rental-manager/pathsManifest';
import { closeNotification, showModalNotification } from '@common/actions/NotificationActions';
import { trackValidationError } from '@common/actions/TrackingActions';
import { resetNewTermSettings, saveNewTermSettings } from '@rental-manager/actions/DashboardActions';
import { pageFlows } from '../../pageFlows';
import REQUEST_STATUS from '@common/constants/requestStatus';
import { logError } from '@zg-rentals/log-error';

const mapStateToProps = (state, { propertyId }) => {
  const { leaseId } = state.payments.landlord.onboarding[propertyId];
  const { leasesForProperty, newTermSettings } = state.payments.landlord.property;
  const { rentAmount, editMode } = newTermSettings;
  const { baseRent: baseRentFromLease } = leasesForProperty[leaseId] || {};

  return {
    monthlyRent: baseRentFromLease || rentAmount,
    editMode,
    requestStatus: REQUEST_STATUS.SUCCESS,
    rentTermsKey: '',
    config: state.payments.landlord.config,
    user: state.user,
    currentProperty: state.payments.landlord.property.listingDetails,
  };
};

const mapDispatchToProps = (dispatch, { baseUrl, propertyId }) => ({
  onSubmit: (paymentSettings, editMode) =>
    Promise.resolve()
      .then(() => dispatch(closeNotification()))
      .then(() => dispatch(saveNewTermSettings({ rentAmount: paymentSettings.monthlyRent })))
      .then(() => editMode && dispatch(saveNewTermSettings({ currentPage: pageFlows.NewTenantConfirmation })))
      .then(() => !editMode && dispatch(saveNewTermSettings({ currentPage: pageFlows.NewTenantMoveInCostsPage })))
      .then(() => {
        return dispatch(push(baseUrl + paths.dashboard.setupNewTermPage));
      })
      .then(() => editMode && dispatch(showModalNotification(PAYMENT_SETTINGS_UPDATED)))
      .catch((err) => {
        logError({ error: err });
        dispatch(showModalNotification(DEFAULT_ERROR));
        return { error: true };
      }),
  onBack: () =>
    Promise.resolve()
      .then(() => dispatch(closeNotification()))
      .then(() => dispatch(goBack())),
  onCancel: () =>
    Promise.resolve()
      .then(() => dispatch(closeNotification()))
      .then(() => dispatch(saveNewTermSettings({ currentPage: pageFlows.NewTenantConfirmation })))
      .then(() => dispatch(push(baseUrl + paths.dashboard.setupNewTermPage))),
  onClose: () =>
    Promise.resolve()
      .then(() => dispatch(closeNotification()))
      .then(() => dispatch(resetNewTermSettings()))
      .then(() => dispatch(push(baseUrl))),
  trackValidationError: (data) => dispatch(trackValidationError(data)),
});

const mergeProps = (stateProps, dispatchProps) => ({
  ...stateProps,
  ...dispatchProps,
  onSubmit: (paymentSettings) => dispatchProps.onSubmit(paymentSettings, stateProps.editMode),
  onClose: () => dispatchProps.onClose(stateProps.editMode),
});

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(RentAmountPage);
